module.exports.version = 'v11.12.6-5610f779';
